import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { NgAnimateScrollService } from 'ng-animate-scroll';

@Component({
  selector: 'app-intro-screen',
  templateUrl: './intro-screen.component.html',
  styleUrls: ['./intro-screen.component.scss']
})
export class IntroScreenComponent implements OnInit {

  public backgroundImage: any
  public screenVisible: boolean = false
  public hideIntroScreen:boolean = false

  @ViewChild('introScreen', {static:false}) introScreen:ElementRef
  @Input() _editable: any
  @Input() background_images: any
  constructor(
    private animateScrollService: NgAnimateScrollService
  ) { }

  ngOnInit() {
    this.backgroundImage = this.selectRandomBackgroundImage().image

    if(sessionStorage.getItem('hideIntro') === 'true') {
      this.hideIntroScreen = true
    }
  }

  getImages(){}
  selectRandomBackgroundImage(){
    console.log(this.background_images);
    return this.background_images[Math.floor(Math.random()*this.background_images.length)]
  }


  public onIntersection({ target, visible }: { target: Element; visible: boolean }): void {

    if(!visible) {      
      let scrollPos = window.scrollY
      this.hideIntroScreen = true

      sessionStorage.setItem('hideIntro', 'true')

      window.scrollTo(scrollPos, 0)
    }

    // this.introScreen.nativeElement.classList.add(target, visible ? 'active' : 'inactive')
  }

}
